import { Observable } from 'rxjs'
import http from '../adapters/http'
import { validTokenCookie } from '~/utils/general'

export default {
  getInvoices(params, headers) {
    if (headers.Authorization) headers.Authorization = validTokenCookie()
    const url = `${process.env.HUB_SERVICE_URL}/api/v1/${window.$nuxt.$auth.user.organization_id}/invoices/me`
    return new Observable(
      (observer) => new http.GET(observer, url, params, headers)
    )
  },
}
